'use client'

import { GoogleTagManager as BaseGoogleTagManager, sendGTMEvent } from '@next/third-parties/google'

export function GoogleTagManager() {
    const gtmId = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID
    const isProduction = process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'

    if (!gtmId || !isProduction) return null

    return <BaseGoogleTagManager gtmId={gtmId} />
}

interface BaseGTMEvent {
    distinctId?: string
}

export interface SubscriptionPurchaseEvent extends BaseGTMEvent {
    event: 'subscription_purchase'
    value?: number
    currency?: string
    transaction_id?: string
    plan?: string
    user_email?: string
}

export interface CreatedUserEvent extends BaseGTMEvent {
    event: 'signed_up'
    user_email?: string
}

export interface CtaButtonClicked extends BaseGTMEvent {
    event: 'cta_button_clicked'
}

export type GTMEvent = SubscriptionPurchaseEvent | CreatedUserEvent | CtaButtonClicked

export const pushGTMEvent = (event: GTMEvent) => {
    try {
        sendGTMEvent(event)
    } catch (error) {
        console.log('Error pushing GTM event', error)
    }
}
